import type { DeepPartial } from 'ts-essentials';

import { getIsCustomFont } from 'hb-react/backoffice/components/PageBuilder/utils/getIsCustomFont';
import type { NetworkTheming } from 'hb-react/types';

export const getCustomFontName = (
  networkTheming?: DeepPartial<NetworkTheming>,
) => {
  if (!networkTheming) {
    return undefined;
  }

  if (getIsCustomFont(networkTheming)) {
    return networkTheming?.global?.custom_font_name;
  }
};
